import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions'
import mutations from './mutations';
Vue.use(Vuex);

import createLogger from 'vuex/dist/logger'
const debug = process.env.NODE_ENV !== 'production'
import VuexPersistence from "vuex-persist";
const vuexPersisted = new VuexPersistence({
  storage: window.sessionStorage,
  render:state=>({
    ...state
  })
});

export default new Vuex.Store({
  state: {
    test:'',
    isMobild:false,
    count: 0,
    chainId:'',
    accounts:[],
    balance:0,
    sid:'',
    profileSid:'',
    isReload: true,
    provider:''
  },
  getters: {
    getMyAccount: (state) => {
      let myAccount=state.accounts[0];
      return myAccount;
    }
  },
  mutations,
  actions,
  plugins: [
    // vuexPersisted.plugin,
    createLogger()
  ]
});



// WEBPACK FOOTER //
// ./src/store/index.js